import React, { useState } from 'react'
import { Form, Input, Modal,App} from 'antd'
import { useYonghuAddMutation } from '../../store/dianshangtaizhangApi';
import { PlusSquareOutlined } from '@ant-design/icons';
function FirmUserAdd(props) {
    console.log(props);
    
    const { message } = App.useApp()
    const [open, setOpen] = useState(false)
    const [form] = Form.useForm(); 
    const [info,setInfo] = useState({
        "yh_name" : '',
        "yh_phone" : '',
        "yh_qx" : '',
        "yh_juese" : '1',
        "yh_qy_id" : props.qy_id,
        "yh_qy_name" : props.qy_name,
        "yh_state" : '1',
        "yh_uid" : props.eu_id,
        "yh_uname" : props.eu_name,
        'phone_code':'297757'
    })
    const [submit] = useYonghuAddMutation();
    const handleSubmit = async () => {
        try {
            const result = await submit(info).unwrap();
            
            if (result.Status === 'success') {
                message.success('新增企业成功！');
                form.resetFields();
                setOpen(false);
            } else {
                message.error('新增企业失败！' + result.Message);
            }
        } catch (error) {
            message.error('请求失败：' + (error.data?.Message || error.message));
        }
    }
    return (
        <>
            <a onClick={() => { setOpen(true) }}><PlusSquareOutlined /> 新增操作员</a>
            <Modal
                open={open}
                width={800}
                onCancel={() => { setOpen(false) }}
                onOk={handleSubmit}
                title='新增操作员'
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}                                  
                >                                                       
                    <Form.Item name="yh_name" wrapperCol={{span:10}} required label='姓名'>                        
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,yh_name:e.target.value}))
                            }}
                        />
                    </Form.Item>                       
                    <Form.Item name="yh_phone" wrapperCol={{span:10}} required label='手机号码'>                        
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,yh_phone:e.target.value}))
                            }}
                        />
                    </Form.Item>                                                                                                                
                    <Form.Item name="yh_juese" wrapperCol={{span:10}} required label='角色'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_juese:e.target.value}))
                        }}/>
                    </Form.Item>                                                                                                              
                    <Form.Item name="yh_qx" wrapperCol={{span:10}} label='权限'>                        
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,yh_qx:e.target.value}))
                            }}
                        />
                    </Form.Item>                                                                                                                
                </Form>
            </Modal>
        </>
    )
}

export default FirmUserAdd